import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const ModalTotalDiscount = ({ isVisible, onClose, orderId }) => {
  const [discountType, setDiscountType] = useState();
  const [discount, setDiscount] = useState();
  const [tax, setTax] = useState();

  // Function to handle the product update logic
  const updateProduct = async () => {
    try {
      const response = await axios.put(
        `https://server-gs.vercel.app/admin/add-discount-taxes/${orderId}`,
        {
          discountType,
          discount,
          tax,
        }
      );
      console.log("Response:", response.data);
      Swal.fire({
        title: "Success!",
        text: "Added on total discount successfully.",
        icon: "success",
        timer: 1500, // Auto-close after 1.5 seconds
        showConfirmButton: false, // No "OK" button
      })
      onClose(); // Close modal on success
    } catch (error) {
      console.error("Error updating product:", error);
      alert("Failed to update product.");
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center z-50 ">
      <div className="bg-white border border-gray-200 rounded-lg shadow-xl w-[90%] max-w-[400px] mx-5 sm:mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center rounded-t-lg py-4 px-6 bg-blue-600">
          <h1 className="text-white text-xl font-semibold font-roboto">
            Add Total Products Discount
          </h1>
          <button
            onClick={onClose}
            aria-label="Close"
            className="w-8 h-8 rounded-full flex justify-center items-center hover:bg-blue-700 transition-colors duration-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          {/* Discount Input */}
          <div className="mb-6">
            <label className="block text-lg font-roboto font-medium text-gray-700 mb-2">
              Discount
            </label>
            <div className="flex gap-3">
              <select
                value={discountType}
                onChange={(e) => setDiscountType(e.target.value)}
                className="w-1/3 border border-gray-300 rounded-lg px-3 py-2 text-lg font-roboto focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
              >
                <option value="">Select Type</option>
                <option value="%">%</option>
                <option value="$">$</option>
              </select>
              <input
  type="number"
  value={discount ?? ""}
  onChange={(e) => {
    const value = e.target.value;

    // Allow empty input for smooth deletion
    if (value === "") {
      setDiscount(null);
      return;
    }

    // Parse to float and check for non-negative value
    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue) && parsedValue >= 0) {
      setDiscount(parsedValue);
    }
  }}
  placeholder="Enter discount"
  className="w-2/3 border border-gray-300 rounded-lg px-4 py-2 text-lg font-roboto focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
/>

            </div>
          </div>

          {/* Submit Button */}
          <button
            onClick={updateProduct}
            className="w-full px-6 py-3 bg-blue-600 text-white font-roboto font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-300"
          >
            Add Discount
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalTotalDiscount;
